import React from "react"
import {
  OverlayTrigger,
  Tooltip as RbTooltip
} from "react-bootstrap"

const Tooltip = props => {
  const {
    placement = "bottom",
    title,
    children,
    ...otherProps
  } = props

  if (!title) return children

  return (
    <OverlayTrigger
      placement={placement}
      {...otherProps}
      overlay={
        <RbTooltip id={title} {...props}>
          {title}
        </RbTooltip>
      }
    >
      {children}
    </OverlayTrigger>
  )
}

export default Tooltip